bcn.imageUploadLimit = (function () {

  'use strict';
   function check_to_hide_or_show_add_link() {
     if ($('#photos .nested-fields:visible').length >= 10) {
       $('#photos .js-add-photo').hide();
     } else {
       $('#photos .js-add-photo').show();
     }
   }

   $('#photos').bind('cocoon:after-insert', function() {
     check_to_hide_or_show_add_link();
   });

   $('#photos').bind('cocoon:after-remove', function() {
     check_to_hide_or_show_add_link();
   });

   return {
     init: function () {
       check_to_hide_or_show_add_link();
     }
   };

})();
